module.exports = __webpack_public_path__ + "media/images/idioma-77173fe48e3c591037328158d71dbbd2.png";